module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2s1xf"))).then(() => module.bundle.root('f4eak'));